
import React from 'react'
import { injectIntl } from 'react-intl'
const LoaderScreen = () => (
  <div className="loader">
    <div className="loader--item">
      <span className="icon-hex-border" />
      <span className="icon-rocket-loading"> </span>
    </div>
    <div className="loader--text">Loading 100%</div>
  </div>
)

LoaderScreen.propTypes = {}

export default injectIntl(LoaderScreen)
